import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

const colors = {
  green: {
    backgroundColor: tokens.colorPaletteDarkGreenBackground2,
    color: tokens.colorPaletteDarkGreenForeground2,
  },
  gray: {
    backgroundColor: tokens.colorNeutralBackground1Hover,
    color: tokens.colorNeutralForeground2,
  },
  purple: {
    backgroundColor: tokens.colorPalettePurpleBackground2,
    color: tokens.colorPalettePurpleForeground2,
  },
  brown: {
    backgroundColor: tokens.colorPaletteBrownBackground2,
    color: tokens.colorPaletteBrownForeground2,
  },
  blue: {
    backgroundColor: tokens.colorPaletteBlueBackground2,
    color: tokens.colorPaletteBlueForeground2,
  },
};

export type TColorKey = keyof typeof colors;

export const useStyles = makeStyles({
  cardContainer: {
    flexGrow: 1,
    height: '68px',
  },
  card: {
    height: '68px',
    ...shorthands.padding('12px'),
  },
  cardText: {
    ...shorthands.overflow('hidden'),
    maxWidth: '180px',
    display: 'block',
  },
  cardDescription: {
    ...shorthands.overflow('hidden'),
    maxWidth: '180px',
    display: 'block',
  },
  cardWarning: {
    display: 'inline',
    color: 'var(--Status-Warning-Foreground-1-Rest, #BC4B09)',
    textDecorationStyle: 'dashed',
    textDecorationLine: 'underline',
  },
  iconWarning: {
    color: 'var(--Status-Warning-Foreground-1-Rest, #BC4B09)',
    cursor: 'pointer',
  },
});

export const useIconStyles = makeStyles({
  iconContainer: {
    height: '44px',
    width: '44px',
    boxSizing: 'border-box',
    backgroundColor: '#9AD29A',
    color: '#063B06',
    ...shorthands.borderRadius('4px'),
    ...shorthands.padding('12px'),
  },
  icon: {
    height: '20px',
    width: '20px',
  },
});

export const useIconColorStyles = makeStyles({
  ...colors,
});
